import { useTranslation } from 'react-i18next';
import madeSimpleImage from 'assets/images/accounting/finance-management.jpg';
import {
  BlueSecondarySection,
  Overline,
  SectionHeading,
  SectionInner,
  SplitImage,
  SplitRow,
} from '../HostfullyAccountingMarketing.styles';

const MadeSimpleSection = () => {
  const { t } = useTranslation();

  return (
    <BlueSecondarySection data-testid="marketing-made-simple">
      <SectionInner>
        <SplitRow>
          <SplitImage
            src={madeSimpleImage}
            alt={t('pageHostfullyAccounting.marketing.madeSimple.imageAlt')}
            loading="lazy"
          />
          <div>
            <Overline $onDark>
              {t('pageHostfullyAccounting.marketing.madeSimple.overline')}
            </Overline>
            <SectionHeading $onDark>
              {t('pageHostfullyAccounting.marketing.madeSimple.title')}
            </SectionHeading>
          </div>
        </SplitRow>
      </SectionInner>
    </BlueSecondarySection>
  );
};

export default MadeSimpleSection;
